import { Component, OnInit } from '@angular/core';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ExportInterfaceConfigurationDataSelectionType } from 'src/app/base/models/models.swagger.generated';
import { Observable, of } from 'rxjs';
import { MultiSelectFilterType } from 'src/app/base/shared/multi-select-filter/multi-select-filter-type';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectFilterComponent } from '../../../../../base/shared/multi-select-filter/multi-select-filter.component';
import { NgClass } from '@angular/common';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { EnumDropDownListComponent } from '../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';

@Component({
    selector: 'app-configuration-form-backlog',
    templateUrl: './configuration-form-backlog.component.html',
    styleUrls: ['./configuration-form-backlog.component.scss'],
    imports: [ReactiveFormsModule, EnumDropDownListComponent, AppErrorMessagesComponent, NgClass, MultiSelectFilterComponent, TranslateModule]
})
export class ConfigurationFormBacklogComponent implements OnInit {

  public DataSelectionType = ExportInterfaceConfigurationDataSelectionType;
  public multiSelectItemFilter = MultiSelectFilterType.MultiSelectItem;

  private locationList: string[] = ["MAIN", "LBT-ZL", "BNL-ZL", "AT-ZL"];

  public get isLocationRequired():boolean{
    return this.configurationFormBacklog.getRawValue().dataSelectionType == ExportInterfaceConfigurationDataSelectionType.AllCustomers;
  }

  public get configurationFormBacklog(): UntypedFormGroup {
    return this.configurationFormService.configurationFormBacklog;
  }

  public get selectedLocations(): string[] {
    return this.configurationFormBacklog.get('backlogFilterLocations').value;
  }

  public set selectedLocations(value: string[]) {
    this.configurationFormBacklog.get('backlogFilterLocations').setValue(value);
  }

  public getLocations(searchText: string): Observable<string[]> {
    return of(this.locationList);
  }

  constructor(private configurationFormService: ConfigurationFormCoordinatorService) { }

  ngOnInit() {
    this.configurationFormBacklog.get('dataSelectionType').valueChanges.subscribe((value)=>{
      if(value == ExportInterfaceConfigurationDataSelectionType.AllCustomers){
        this.configurationFormBacklog.get("backlogFilterLocations").setValidators([Validators.required, Validators.pattern(/[\S]/)]);
        this.configurationFormBacklog.get("backlogFilterLocations").updateValueAndValidity();
      }
      else{
        this.configurationFormBacklog.get("backlogFilterLocations").setValidators([Validators.pattern(/[\S]/)]);
        this.configurationFormBacklog.get("backlogFilterLocations").updateValueAndValidity();
      }
    });
  }

}
